import React from 'react';
import { Descriptions } from 'antd';
import { getDefaultPortion } from '../../../../../core-module/helpers/defaultPortionHelpers';
import { CamasysCustomer } from '../../../../../core-module/services/logistics/types';

interface Props {
  readonly firstName: string;
  readonly lastName: string;
  readonly prefix: string | null;
  readonly customerNumber: number;
  readonly camasysCustomer: CamasysCustomer;
}

const ProfileComponent: React.FC<Props> = ({
  firstName,
  lastName,
  prefix,
  customerNumber,
  camasysCustomer
}) => {
  const defaultPortion = camasysCustomer.defaultPortie
    ? getDefaultPortion(camasysCustomer.defaultPortie.portieID)
    : null;

  return (
    <>
      <Descriptions bordered column={1}>
        <Descriptions.Item label='Voornaam'>
          <span>{firstName}</span>
        </Descriptions.Item>
        <Descriptions.Item label='Achternaam'>
          <span>
            {prefix ? `${prefix} ` : ''}
            {lastName}
          </span>
        </Descriptions.Item>
        <Descriptions.Item label='Klantnummer'>
          <span>{customerNumber}</span>
        </Descriptions.Item>
        <Descriptions.Item label='Telefoonnummer'>
          <span>
            {camasysCustomer.telefoonnummer}{' '}
            {camasysCustomer.telefoonnummer2 ? ` | ${camasysCustomer.telefoonnummer2}` : ''}
          </span>
        </Descriptions.Item>
        <Descriptions.Item label='Vaste route opmerking'>
          <span>{camasysCustomer.opmerking}</span>
        </Descriptions.Item>
        <Descriptions.Item label='Af te geven maaltijdoverzichten'>
          <span>{camasysCustomer.maaltijdOverzichtAantal}</span>
        </Descriptions.Item>
        <Descriptions.Item label='Standaard portie'>
          <span>{defaultPortion ? defaultPortion.description : '-'}</span>
        </Descriptions.Item>
      </Descriptions>
    </>
  );
};

export { ProfileComponent };
